import { Stack } from '@mui/material';
import { t } from 'i18next';
import { NoData } from '../../../components/NoData';
import { useComponentResponsiveProps } from '../../../hooks/useComponentResponsiveProps';
import { PieChart } from './PieChart';

type Props = {
  title: string;
};

type ResponsiveContentType = {
  direction: 'column' | 'row-reverse';
  chartRadius: number;
  chartWidth: number;
  noDataHeight: string;
};

export const ChartContent = ({ title }: Props) => {
  const [responsiveComponentRef, responsiveConfig] = useComponentResponsiveProps<ResponsiveContentType, HTMLDivElement>({
    xs: {
      direction: 'column',
      chartRadius: 70,
      chartWidth: 25,
      noDataHeight: '6.875rem',
    },
    sm: {
      direction: 'row-reverse',
      chartRadius: 110,
      chartWidth: 40,
      noDataHeight: '15rem',
    },
  });

  return (
    <Stack
      data-role="blank-chart-content"
      ref={responsiveComponentRef}
      direction={responsiveConfig.direction}
      spacing={2}
      sx={{
        '& > *': {
          flex: 1,
        },
      }}
    >
      <Stack justifyContent={'center'} alignItems={'center'}>
        <PieChart title={title} radius={responsiveConfig.chartRadius} chartWidth={responsiveConfig.chartWidth} />
      </Stack>
      <NoData title={t('blankState.priorityFixes.title')} withBackground sx={{ padding: 0, px: 7, minHeight: responsiveConfig.noDataHeight }} />
    </Stack>
  );
};
